import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetFullURL } from "../../CommonComponents/GlobalConfFiles/URLs";
import { useFetch } from "../../hooks/useFetch";
import { useMessage } from "../../hooks/UseMessage";
import OverviewInput from "../../CommonComponents/InitialInput/OverviewInput"
import OverviewButtons from "./Components/OverviewButtons";
import { LoadingScreen } from "../../CommonComponents/LoadingScreen/index";
import ListModal from "../../CommonComponents/Modal/DropDownModal/DropDownListMUI";
import CircleButton from "../../CommonComponents/CircleButton";
import MessageLog from "../../CommonComponents/Messages/MessageLog";
import cardlogo from "../../Assets/cardLogo.svg"

function LogisticStationOverview() {
  let navigate = useNavigate();

  const [logisticStation, setLogisticStation] = useState();
  const [showLogisticStationList, setShowLogisticStationList] = useState(false);
  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();

  const [_getLogisticStationList, _logisticStationList, , , , , , _loadingtLogisticStationList] =
    useFetch(GetFullURL("LogisticStationList"), { method: "POST" });

  const [_getLogisticStationExists, , , , , , , _loadingtLogisticStationExist] = useFetch(
    GetFullURL("LogisticStationExist"),
    { method: "POST" }
  );

  function clearMessages(e) {
    e.stopPropagation();
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        break;
      case "error":
        _setErorMessages([]);
        break;
      case "warning":
      default:
        break;
    }
  }
  const operationLoading = _loadingtLogisticStationExist || _loadingtLogisticStationList;
  return (
    <section className="heroCard heroPartner">
      {operationLoading && <LoadingScreen />}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="cardHeader">
                <h2>
                  <span>
                  <img src={require("../../Assets/icon/Logistic.png")} className="img-fluid cardLogo" alt="" />
                  </span>
                  Logistic Station Overview
                </h2>
              </div>
              <div className="cardBody">
                <div className="cardInput">
                  <OverviewInput
                    setDocument={setLogisticStation}
                    document={logisticStation}
                    placeholder="Logistic Station id here..."
                  />
                </div>
                <div className="cardButton">
                  <CircleButton
                    buttonText={`List of Logistic Stations`}
                    clickHandler={() => {
                      _getLogisticStationList({}, () => {
                        setShowLogisticStationList(true);
                      });
                    }}
                  />
                  <OverviewButtons
                    logisticStation={logisticStation}
                    navigate={navigate}
                    _getLogisticStationExists={_getLogisticStationExists}
                    _createErrorMessage={_createErrorMessage}
                  />
                </div>
              </div>
            </div>
            <MessageLog
              errorMessages={[..._errorMessages]}
              successMessages={[]}
              warningMessages={[]}
              clearMessages={clearMessages}
            ></MessageLog>
            <div className="cardAlert">
              <ListModal
                setId={setLogisticStation}
                dataList={_logisticStationList}
                showListModal={showLogisticStationList}
                setShowModal={setShowLogisticStationList}
                title="List Of Logistic Stations"
                columns={[
                  { field: "id", headerName: "LogisticStation ID", width: 100 },
                  { field: "logisticStationTypeId", headerName: "LogisticStation Type", width: 250 },
                  { field: "name", headerName: "Name", width: 350 },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LogisticStationOverview;
